import React, { useEffect, useState } from "react";
import light from "../Assests/Light.svg";
import pending from "../Assests/pending.svg";
import { updateConnects } from "../Services/ShowsApi";
import { setUserMessage, toggleSearchPageLoad } from "../redux/valueSlice";
import { useDispatch } from "react-redux";
import { CometChat } from '@cometchat/chat-sdk-javascript';
import cardMsg from "../Assests/cardMsg.svg";
import { setIsChatOpen } from "../redux/valueSlice";

const styles = {
  buttonContainer: {
    display: "flex",
    gap: "0.8vh",
  },
  connectText: {
    textAlign: "right",
    color: "white",
    fontSize: '1.8vh',
    fontWeight: "bolder",
    letterSpacing: '0.064vh',
    wordWrap: "break-word",
  },
  connectIcon: {
    width: '2.8vh',
    height: '2.8vh',
    position: "relative",
    overflow: "hidden",
  },
  button: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "1.0vh 1.8vh",
    backgroundColor: "rgba(41, 104, 254, 0.8)",
    color: "#fff",
    border: "none",
    borderRadius: '1.8vh',
    cursor: "pointer",
    fontSize: "1.8vh",
    fontWeight: "bold",
    transition: "all 0.3s ease",
    gap: '0.8vh',
    "&:hover": {
      backgroundColor: "#0056b3",
    },
    "&:active": {
      backgroundColor: "#004080",
    },
    "&:disabled": {
      backgroundColor: "rgba(150, 150, 150, 0.5)",
      cursor: "not-allowed",
    },
  },
  pendingButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "1.0vh 1.8vh",
    backgroundColor: "rgba(41, 104, 254, 0.8)",
    color: "#fff",
    border: "none",
    borderRadius: '1.8vh',
    cursor: "pointer",
    fontSize: "1.8vh",
    transition: "all 0.3s ease",
    gap: '0.8vh',
    backgroundColor: "rgba(255, 166, 0, 0)",
    "&:hover": {
      backgroundColor: "rgba(255, 166, 0, 0)",
    },
  },
  connectedButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "1.0vh 1.8vh",
    color: "#fff",
    border: "0.1vh solid #fff",
    borderRadius: '1.8vh',
    cursor: "pointer",
    fontSize: "1.8vh",
    fontWeight: "bold",
    transition: "all 0.3s ease",
    gap: '0.8vh',
    backgroundColor: "rgba(255, 166, 0, 0)",
    "&:hover": {
      backgroundColor: "rgba(255, 166, 0, 0)",
    },
  },
};

const ConnectButton = ({ ConnectionStatus: initialStatus, ReceiverID, fullWidth }) => {

  const dispatch = useDispatch();
  const [connectionStatus, setConnectionStatus] = useState(initialStatus);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setConnectionStatus(initialStatus)
  }, [initialStatus])

  const data = {
    SenderID: localStorage.getItem("user_id"),
    ReceiverID: ReceiverID,
  };

  const handleConnectionClick = async () => {

    dispatch(setIsChatOpen(true))

    const usersRequest = new CometChat.UsersRequestBuilder()
      .friendsOnly(true)
      .setLimit(50)
      .build();
    const connections = await usersRequest.fetchNext();
    let selectedUser = connections.find((user) => user.uid === (localStorage.getItem('user_id') === data.ReceiverID ? data.SenderID : data.ReceiverID));
    dispatch(setUserMessage([selectedUser]))
  }

  const handleConnect = async () => {
    try {
      setIsLoading(true);
      await updateConnects(data);
      // Update status to PENDING after successful API call
      setConnectionStatus("PENDING");

      // Dispatch to load search card status after connection completes
      dispatch(toggleSearchPageLoad());
    } catch (error) {
      console.error("Connection failed:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Don't show anything if it's the user's own profile
  if (connectionStatus === "SELF") {
    return null;
  }


  // Determine button properties based on connection status
  const getButtonConfig = () => {
    switch (connectionStatus) {
      case "NOT SENT":
        return {
          text: isLoading ? "Sending" : "Connect",
          onClick: handleConnect,
          style: { ...styles.button, ...(fullWidth && { width: "100%" }) },
          img: light,
          disabled: isLoading,
        };
      case "PENDING":
        return {
          text: "Pending",
          disabled: true,
          style: { ...styles.button, ...styles.pendingButton, ...(fullWidth && { width: "100%" }) },
          img: pending,
        };
      case "ACCEPTED":
        return {
          text: "Message",
          onClick: handleConnectionClick,
          disabled: false,
          style: { ...styles.button, ...styles.connectedButton, ...(fullWidth && { width: "100%" }) },
          img: cardMsg,
        };
      default:
        return {
          text: "Connect",
          onClick: handleConnect,
          style: { ...styles.button, ...(fullWidth && { width: "100%" }) },
          img: light,
        };
    }
  };

  const buttonConfig = getButtonConfig();

  return (
    <button
      style={buttonConfig.style}
      onClick={buttonConfig.onClick}
      disabled={buttonConfig.disabled}
    >
      <div style={styles.connectText}>{buttonConfig.text}</div>
      {buttonConfig.img && !isLoading && (
        <div style={styles.connectIcon}>
          <img src={buttonConfig.img} alt="Button icon" style={{ width: buttonConfig.text === 'Message' ? "75%" : "100%", height: "100%", zIndex: 1 }} />
        </div>
      )}
      {isLoading && (
        <div style={styles.connectIcon}>
          {/* Add your loading spinner here if you have one */}
        </div>
      )}
    </button>
  );
};

export default ConnectButton;